"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  cs: {
    orders: {
      actions: {
        addNewOrder: 'Přidat objednávku',
        all: 'Všechny objednávky'
      },
      listPage: {
        title: 'Objednávky',
        table: {
          filter: {
            number: 'Číslo'
          },
          columns: {
            contact: 'Kontakt',
            dateOfOrder: 'Datum objednání',
            number: 'Číslo',
            offer: 'Nabídka',
            opportunity: 'Příležitost',
            owner: 'Vlastník',
            state: 'Stav',
            total: 'Celkem',
            totalUserCurrency: 'Celkem v {currency}'
          }
        }
      },
      order: {
        newEntity: 'Nová objednávka',
        contact: {
          label: 'Kontakt',
          helperText: '',
          helperTextPreview: ''
        },
        commissionTotal: {
          label: 'Celková provize',
          helperText: '',
          helperTextPreview: ''
        },
        currency: {
          label: 'Měna',
          helperText: '',
          helperTextPreview: ''
        },
        dateOfOrder: {
          label: 'Datum objedníní',
          helperText: '',
          helperTextPreview: ''
        },
        number: {
          label: 'Číslo',
          helperText: 'Pro automatické vygenerování čísla ponechte nevyplněno.',
          helperTextPreview: ''
        },
        offer: {
          label: 'Nabídka',
          helperText: '',
          helperTextPreview: ''
        },
        opportunity: {
          label: 'Příležitost',
          helperText: '',
          helperTextPreview: ''
        },
        owner: {
          label: 'Vlastník',
          helperText: '',
          helperTextPreview: ''
        },
        salesMargin: {
          label: 'Obchodní marže',
          helperText: '',
          helperTextPreview: ''
        },
        subjects: {
          title: 'Předmět',
          discount: {
            label: 'Sleva',
            helperText: '',
            helperTextPreview: ''
          },
          commission: {
            label: 'Provize',
            helperText: '',
            helperTextPreview: ''
          },
          list: {
            package: 'Velikost balení'
          },
          listPrice: {
            label: 'Ceníková cena',
            helperText: '',
            helperTextPreview: ''
          },
          price: {
            label: 'Prodejní cena',
            helperText: '',
            helperTextPreview: ''
          },
          product: {
            label: 'Produkt',
            helperText: '',
            helperTextPreview: ''
          },
          quantity: {
            label: 'Množství',
            helperText: '',
            helperTextPreview: ''
          },
          salesMargin: {
            label: 'Obchodní marže',
            helperText: '',
            helperTextPreview: ''
          },
          subjectTotal: {
            label: 'Za položku celkem',
            helperText: '',
            helperTextPreview: ''
          },
          unit: {
            label: 'Jednotka',
            helperText: '',
            helperTextPreview: ''
          }
        },
        total: {
          label: 'Celkem',
          helperText: '',
          helperTextPreview: ''
        },
        numberOfSubjects: '{number, plural, =0 {žádné položky} one {1 položka} few {{number} položky} other {{number} položek}}'
      },
      myOrdersScoringBlog: {
        title: 'Moje objednávky'
      },
      ordersList: 'Objednávky'
    }
  }
};
var _default = messages;
exports.default = _default;